module.exports = __webpack_public_path__ + "img/kcisa.acba869d.svg";